import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { PAGE_SIZE } from 'core/utils/constants';
import httpclient from 'libs/Axios';
import { useEffect } from 'react';

export const useFetchLanguageList = (list, setlist) => {
  const authData = useAuth();
  useEffect(() => {
    const request = async () => {
      // const response = await httpclient().get(`/master/language/list?${PAGE_SIZE}`);
      // const data = response?.data?.data;
      // setlist(data[Object.keys(data).at(0)?.toString() as string] || []);
      setlist(authData?.MASTER_DATA?.languageList || []);
    };

    request();
  }, []);
};
